module.exports = __webpack_public_path__ + "img/arrow.1148c085.svg";